import { CommonType } from "../interfaces/common.interface";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const numberPattern = /^\+?[0-9]+$/;
const googlePlaceAPIKey = 'AIzaSyCsu9_b70IS1m92XjvaZw96NTNTD4fgHN4';
const IPurl = `https://ipinfo.io`;
const defaultLanguage = 'es'; // en, es  // Default es but temp en
const defaultTheme = 'dark'; // en, es  // Default es but temp en
const languageArray = [
  { prefix: 'en', name: 'English' },
  { prefix: 'es', name: 'Español' },
];
const paginationArray = [10, 25, 50, 100];

const localStorageKeys = ['vendorUserDetail', 'selectedStore', 'token'];

// AES-256 key: 32 characters
const secretKey = 'aB45dfmuybikH7gQpadminrNd3edd5Ci';

// AES IV: 16 characters
const iv = 'XyZ12muybieed43s';

const StatusActiveInactive: CommonType[] = [
  { id: 1, name: 'Active', translateLabel: 'STATUS.ACTIVE' },
  { id: 2, name: 'Inactive', translateLabel: 'STATUS.INACTIVE' },
]
const PaymentCycle: CommonType[] = [
  { id: 1, name: 'Monthly', translateLabel: 'PAYMENT_CYCLE.MONTHLY' },
  { id: 2, name: 'Yearly', translateLabel: 'PAYMENT_CYCLE.YEARLY' },
]

export {
  emailPattern,
  numberPattern,
  googlePlaceAPIKey,
  IPurl,
  defaultLanguage,
  defaultTheme,
  languageArray,
  paginationArray,
  localStorageKeys,
  secretKey,
  iv,
  StatusActiveInactive,
  PaymentCycle
};

